import React, { useState, useEffect, useRef } from "react";
import styles from "./ChristmasSaleHero.module.scss";
import { useNavigate } from 'react-router-dom';

// Replace these with your actual image imports
import image1 from "images/heros/Christmas Sale/Catch.jpg";
import image2 from "images/heros/Christmas Sale/Dond.jpg";
import image3 from "images/heros/Christmas Sale/MDMD.jpg";
import image4 from "images/heros/Christmas Sale/Scrawl.jpg";
import OutlineText from "../../Utlility/OutlineText/OutlineText";

const ChristmasHero = () => {
    const navigate = useNavigate();
    const images = [image1, image2, image3, image4];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [previousIndex, setPreviousIndex] = useState(null);

    useEffect(() => {
        const timer = setInterval(() => {
            setPreviousIndex(currentIndex);
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 4000);

        return () => clearInterval(timer);
    }, [currentIndex, images.length]);

    return (
        <div className={styles.heroContainer}>
            {/* Stacked fading images */}
            <div className={styles.imageStack}>
                {images.map((src, index) => {
                    let className = styles.heroImage;
                    if (index === currentIndex) {
                        className += ` ${styles.active}`;
                    } else if (index === previousIndex) {
                        className += ` ${styles.previous}`;
                    }
                    return (
                        <img
                            key={index}
                            src={src}
                            alt={`Slide ${index + 1}`}
                            className={className}
                        />
                    );
                })}
            </div>

            {/* Gradient overlay for text readability */}
            <div className={styles.gradientOverlay} />

            {/* Bottom text */}
            <div className={styles.textContainer}>
                <OutlineText text={<h1 className={styles.headline}>
                    <span className={styles.regularText}>A HEAP OF </span>
                    <span className={styles.highlightText}>HO-HO-HILARIOUS</span>
                    <span className={styles.regularText}> GAMES... ONE TAP AWAY!</span>
                </h1>}/>
                
            </div>

            {/* Slide indicators */}
            <div className={styles.indicators}>
                {images.map((_, index) => (
                    <button
                        key={index}
                        className={`${styles.indicator} ${index === currentIndex ? styles.activeIndicator : ""}`}
                        onClick={() => {
                            setPreviousIndex(currentIndex);
                            setCurrentIndex(index);
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChristmasHero;